var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettingWhiteIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_271",
    "data-name": "Rectangle 271",
    width: 17,
    height: 17,
    transform: "translate(1619 975)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_73",
    "data-name": "Mask Group 73",
    transform: "translate(-1619 -975)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(1617.655 973.786)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M17.607,15.179H16.393V13.964H17V11.536H14.571v.607H13.357V10.929a.607.607,0,0,1,.607-.607h3.643a.607.607,0,0,1,.607.607v3.643A.607.607,0,0,1,17.607,15.179Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M14.571,18.214H10.929a.607.607,0,0,1-.607-.607V13.964a.607.607,0,0,1,.607-.607h3.643a.607.607,0,0,1,.607.607v3.643A.607.607,0,0,1,14.571,18.214ZM11.536,17h2.429V14.571H11.536Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M9.107,12.057a2.424,2.424,0,1,1,3.036-2.342h1.214A3.643,3.643,0,1,0,9.107,13.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M17.54,8.227l-1.4,1.232L15.276,8.6,16.739,7.31,15.306,4.833l-2.089.7a5.688,5.688,0,0,0-1.639-.953l-.431-2.155H8.281L7.85,4.584a5.379,5.379,0,0,0-1.645.953l-2.083-.7L2.69,7.31,4.341,8.761a5.4,5.4,0,0,0,0,1.9L2.69,12.119,4.122,14.6l2.089-.7a5.688,5.688,0,0,0,1.639.953L8.281,17h.826v1.214H8.281a1.214,1.214,0,0,1-1.19-.978l-.31-1.53a6.929,6.929,0,0,1-.8-.455l-1.475.5a1.237,1.237,0,0,1-.389.061,1.2,1.2,0,0,1-1.05-.607L1.639,12.726A1.214,1.214,0,0,1,1.888,11.2l1.166-1.02c-.012-.158-.018-.31-.018-.467s.012-.31.024-.461L1.888,8.227A1.214,1.214,0,0,1,1.639,6.7L3.072,4.226a1.2,1.2,0,0,1,1.05-.607,1.237,1.237,0,0,1,.389.061l1.469.5a7.008,7.008,0,0,1,.8-.455l.31-1.53a1.214,1.214,0,0,1,1.19-.977h2.866a1.214,1.214,0,0,1,1.19.978l.31,1.53a6.929,6.929,0,0,1,.8.455l1.475-.5a1.237,1.237,0,0,1,.389-.061,1.2,1.2,0,0,1,1.05.607L17.789,6.7A1.214,1.214,0,0,1,17.54,8.227Z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingWhiteIc);
export default __webpack_public_path__ + "static/media/settingWhiteIc.b078fcf80ccfd7f8acab3fb2bc58087b.svg";
export { ForwardRef as ReactComponent };